<div class="modal-header">
    <i class="far fa-list"></i>
    <h4 class="modal-title">
        {{ 'RTC_DETECTION.TITLE' | translate }}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="dismissModal()"><span
        aria-hidden="true"><i class="far fa-times"></i></span></button>
</div>
<div class="modal-body">

    <div class="body-headline">
        <i class="fal fa-exclamation-triangle"></i>
        <h5>{{'RTC_DETECTION.WARNING.HEADLINE' | translate }}</h5>
    </div>

    <div class="body-content">
        <span>{{ 'RTC_DETECTION.WARNING.MSG' | translate }}</span>
    </div>
</div>
<div class="modal-footer">
    <div class="button-line">
        <button type="button" class="btn btn-outline-dark" (click)="dismissModal()">
            {{'RTC_DETECTION.CANCEL' | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="again()">
        <span>
            {{'RTC_DETECTION.AGAIN' | translate }}
            <i class="fas fa-arrow-right"></i>
        </span>
        </button>
    </div>

    <app-rtc-footer></app-rtc-footer>

</div>

